import { Theme } from "@/theme";
import styled from "styled-components";

export const ErrorPopupContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px 24px 16px;
`;

export const ErrorText = styled.div`
  color: ${Theme.color.darkGrey};
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 18px;
  line-height: 1.4;
`;
